import addScript from "../../../utils/browser/addScript"

const setup = ({ isSDKTrackings }) => {
  const GTMId = JSON.parse(localStorage.getItem("@mobi/analytics"))?.GTMId

  if (isSDKTrackings) {
    window._containerGTM = GTMId
    return addScript(
      `https://libs-digitalanalytics.cloud.itau.com.br/assets/framework-analytics-web.min.js`,
      [
        { key: "id", value: "SDKWebAnalytics" },
        { key: "type", value: "text/javascript" },
      ]
    ).then((_) => {
      const webComponentName = "framework-analytics-web"

      const DOMWebComponentGetElements =
        document?.getElementsByTagName(webComponentName)
      const DOMWebComponentQuantity = DOMWebComponentGetElements?.length

      const doesntExistWebComponentElement = DOMWebComponentQuantity === 0

      if (doesntExistWebComponentElement) {
        const DOMWebComponentElement = document.createElement(webComponentName)
        document.body?.appendChild(DOMWebComponentElement)
      }
    })
  } else {
    return addScript(
      `https://www.itau.com.br/_arquivosestaticos/Itau/defaultTheme/js/da/framework/importLibJSFrameworkDA.js?${GTMId}`,
      [
        { key: "id", value: "importLibJSFrameworkDA" },
        { key: "type", value: "text/javascript" },
      ]
    )
      .then((_) =>
        addScript(
          `https://www.itau.com.br/_arquivosestaticos/Itau/defaultTheme/js/da/framework/frameworkDA.js?${GTMId}`,
          [
            { key: "id", value: "frameworkDA" },
            { key: "type", value: "text/javascript" },
          ]
        )
      )
      .then((_) => {
        console.log("%c @analytics/ga - ready", "color: red")
      })
  }
}

export default setup
